import { Action } from 'redux';

import ChangeLanguage from 'ia-react-core/~/actions/ChangeLanguage';
import { LanguageState } from 'ia-react-core/~/interfaces/LanguageState';
import REDUX from '../../../constants/REDUX';
import changeLanguage from '../../../actions/fn/changeLanguage';

export default function languageReducerFactory({ defaultLocale }: { defaultLocale: string }) {
  return function languageReducer(state: LanguageState = { locale: defaultLocale }, action: Action | ChangeLanguage = { type: '' }) {
    switch (action.type) {
      case REDUX.CHANGE_LANGUAGE:
      case changeLanguage.type:
        return reduceChangeLanguage(state, action as ChangeLanguage);
      default:
        return state;
    }
  };
}

const reduceChangeLanguage = (state: LanguageState, action: ChangeLanguage) => ({
  ...state,
  locale: action.locale,
});
